import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Row,
  Col,
  Radio,
  Select,
  Switch,
  Checkbox,
  DatePicker,
  Collapse,
} from "antd";
import {
  SearchOutlined,
  DownOutlined,
  CloseOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import Icon from "@ant-design/icons";
import { ReactSVG } from "react-svg";
import Geocode from "react-geocode";
import { useDispatch, useSelector } from "react-redux";
import { CompactPicker } from "react-color";
import { RootState } from "reducers/rootReducer";
import { FilterOption } from "utils/PageTypes";

Geocode.setApiKey("AIzaSyDgNagv_ozKWc6IQ75Ol4cH8fxdntOaW6M");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const { TextArea } = Input;
const { Panel } = Collapse;

const PinPop: FC<{
  setActivePop?: (activePop: string) => void;
  marker?: any;
  showDirection?: (pin: any) => void;
  currentLocation?: any;
  setActive?: any;
}> = ({ currentLocation, setActivePop, marker, showDirection, setActive }) => {
  const { location_profiles } = useSelector(
    (state: RootState) => state.dashboard
  );
  const [address, setAddress] = useState();
  const [title, setTitle] = useState();
  const [description, setDescription] = useState();
  const [profile, setProfile] = useState([]);
  const [geometry, setGeometry] = useState();
  const [type, setType] = useState();
  const [paths, setPaths] = useState<any>();
  const [icon, setIcon] = useState<string>("plain");
  const [color, setColor] = useState<string>("green");
  const [flag, setFlag] = useState<string>("green");
  const [timestamp, setTimestamp] = useState(new Date());
  const [userName, setUserName] = useState<any>();
  const [eta, setETA] = useState<ETAObj>({
    enable: false,
    estimatedTime: undefined,
  });
  const [geocode, setGeocode] = useState<GeocodeObj>({
    enable: false,
    radius: undefined,
    alertOn: [],
    insideMinutes: undefined,
    expiry: new Date().getTime(),
  });
  const [edit, toggleEdit] = useState<boolean>(false);
  const { allUsers } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();

  const handleClear = () => {
    if (geometry) setGeometry(null);
    setActivePop("");
  };

  const getPolygonPaths = (polygon: any) => {
    var polygonBounds = polygon.getPath().getArray();
    var bounds = [];
    for (var i = 0; i < polygonBounds.length; i++) {
      var point = {
        lat: polygonBounds[i].lat(),
        long: polygonBounds[i].lng(),
      };
      bounds.push(point);
    }
    bounds.push(bounds[0]);
    reverseGeocode(shapeCenter(bounds));
    return bounds;
  };

  const shapeCenter = (arr: any) => {
    var x = arr.map((xy: any) => xy.lat);
    var y = arr.map((xy: any) => xy.long);
    var cx = (Math.min(...x) + Math.max(...x)) / 2;
    var cy = (Math.min(...y) + Math.max(...y)) / 2;
    return { lat: cx, lng: cy };
  };

  useEffect(() => {
    setTitle(marker.title);
    if (marker.geometry) setGeometry(marker.geometry);
    if (marker.description) setDescription(marker.description);
    if (marker.flag) setFlag(marker.flag);
    if (marker.color) setColor(marker.color);
    if (marker.icon) setIcon(marker.icon);
    if (marker.timestamp) setTimestamp(new Date(marker.timestamp));
    if (marker.gpsTimestamp) setTimestamp(new Date(marker.gpsTimestamp));
    if (marker.eta) setETA(marker.eta);
    if (marker.geofence) setGeocode(marker.geofence);
    if (marker.senderId) {
      const user = allUsers?.find((obj) => obj.id === marker.senderId);
      setUserName(user?.beamId);
    }
    if (marker.settings?.profile?.[0] ?? false) {
      let profiles = [];
      if (marker.objectType === FilterOption.PLACE)
        profiles = location_profiles?.admin?.clbs?.profile ?? [];
      else if (marker.objectType === FilterOption.ASSET)
        profiles = location_profiles?.admin?.asset?.profile ?? [];
      profiles = profiles.filter((e: any) => {
        return marker.settings.profile.indexOf(e.id) !== -1;
      });
      setProfile(
        profiles.map((e: any) => {
          return e.name;
        })
      );
    }
    setType(marker.type);
  }, []);

  useEffect(() => {
    const { mode, coordinates } = marker;
    switch (type) {
      case "polygon":
        if (mode === "new") {
          setPaths(getPolygonPaths(marker.geometry));
        } else {
          setPaths(coordinates);
          reverseGeocode(shapeCenter(coordinates));
        }
        break;
      case "marker":
        setPaths({ lat: marker.lat, long: marker.lng });
        reverseGeocode(marker);
        break;
      case "gps":
        setPaths(() => ({ lat: marker?.lat, long: marker?.lng }));
        reverseGeocode(marker);
        break;
      case "circle":
        setPaths({ lat: marker.lat, long: marker.lng });
        updateGeocode("radius", marker.radius);
        reverseGeocode(marker);
        break;
    }
    if (marker.geometry) marker.geometry.setMap(null);
  }, [type]);

  const handleSave = () => {
    const { mode, id, originalCreatedAt, originalPageMessageId } = marker;
    let data = {
      attributes: {
        title,
        description,
        address,
      },
      display: {
        type,
        flag,
        color,
        icon,
      },
      coordinates: paths,
      timestamp: timestamp.getTime(),
      eta,
      geofence: geocode,
    };

    let edit = undefined;

    if (mode === "edit") {
      edit = { id, originalCreatedAt, originalPageMessageId };
    }
    console.log("mode", mode, data, edit);

    dispatch({
      type: "SEND_MESSAGE",
      payload: { message: title, type: FilterOption.PLACE, data, edit },
    });
    if (geometry) setGeometry(null);
    setActivePop("");
  };

  const handleDirection = () => {
    setActivePop(null);
    showDirection(new google.maps.LatLng(marker.lat, marker.lng));
  };

  const reverseGeocode = (marker: any) => {
    Geocode.fromLatLng(marker.lat, marker.lng).then(
      (response) => {
        setAddress(response.results[0].formatted_address);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  const updateEta = (key: keyof ETAObj, value: ValueOf<ETAObj>) => {
    setETA((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const updateGeocode = (key: keyof GeocodeObj, value: ValueOf<GeocodeObj>) => {
    setGeocode((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  return (
    <div className="pop-content">
      <Row className="d-flex mb-4">
        <Col className="d-flex">
          {!edit ? (
            <h3
              className="mr-3"
              onClick={() => {
                toggleEdit(!edit);
              }}
            >
              {title}
            </h3>
          ) : (
            <Input
              value={title}
              onChange={(e: any) => setTitle(e.target.value)}
              onBlur={() => {
                toggleEdit(!edit);
              }}
              autoFocus
            />
          )}
        </Col>
        <Col>
          <CloseOutlined
            className="close-icon"
            onClick={() => {
              if (geometry) setGeometry(null);
              setActivePop("");
            }}
          />
        </Col>
      </Row>
      <Row className="mt-3 d-line">
        <Col className="pr-3">
          <ReactSVG src="/images/gps-icon.svg" className="pin-icons" />
        </Col>
        <Col className="pr-3">
          <h5 style={{ color: "#40CC52" }}>{JSON.stringify(paths)}</h5>
        </Col>
       
       {userName &&
       <React.Fragment>
        <hr/>
          <Row className="mt-3 d-line">
          <Col className="pr-4">
            <ReactSVG src="/images/male-icon.svg" className="male-icon"/>
          </Col>
          <Col span={18} className="pr-3">
            <h5>{userName}</h5>
          </Col>
        </Row>
        <hr />
      </React.Fragment>
      }


      </Row>
      {type === FilterOption.GPS && (
        <React.Fragment>
          <hr />
          <Row className="mt-3 d-line">
            <Col className="pr-3">
              <ReactSVG src="/images/tester-icon.svg" className="pin-icons" />
            </Col>
            <Col className="pr-3">
              <h5>
                {marker.speed?.toFixed(2) ?? 0} {marker.speedUnit}
              </h5>
            </Col>
            <Col className="pr-3">
              <ReactSVG src="/images/heading-icon.svg" className="pin-icons" />
            </Col>
            <Col>
              <h5>Heading: {Math.floor(marker.heading)}°</h5>
            </Col>
          </Row>

          <hr />
          <Row className="mt-3 d-line">
            <Col className="pr-3">
              <ReactSVG
                src="/images/timestamp-icon.svg"
                className="pin-icons"
              />
            </Col>
            <Col span={18} className="pr-3">
              <h5>Timestamp: {timestamp.toLocaleString()}</h5>
            </Col>
          </Row>
        </React.Fragment>
      )}
      <hr />
      <Row className="mt-3 d-line">
        <Col className="pr-3">
          <ReactSVG src="/images/home-icon.svg" />
        </Col>
        <Col span={18} className="pr-3">
          <h5>{address ? address : "N/A"}</h5>
        </Col>
      </Row>
      <hr />
      <Collapse defaultActiveKey={[]} bordered={false}>
        <Panel
          header={
            <Row className="d-line">
              <Col className="pr-3">
                <EllipsisOutlined style={{ fontSize: 20 }} />
              </Col>
              <Col>
                <h5 style={{ color: "#91A5C6" }}>More details</h5>
              </Col>
            </Row>
          }
          key="1"
        >
          <hr />
          {type === "marker" && marker.mode !== "viewOnly" && (
            <React.Fragment>
              <h5>Select Pin Icon</h5>
              <Row className="d-flex mt-2 map-type-list">
                {["plain", "minus", "cross", "plus", "star", "exclamation"].map(
                  (item) => (
                    <Col span={4} key={item}>
                      <Button
                        onClick={() => {
                          setIcon(item);
                        }}
                        className="primary beam-btn"
                      >
                        <ReactSVG
                          src={`/images/map-${item}-icon.svg`}
                          className={item === icon ? "active-map" : ""}
                        />
                      </Button>
                    </Col>
                  )
                )}
              </Row>
              <hr />
              <h5>Select Pin Color</h5>
              <Row className="d-flex mt-2 map-color-list">
                {["green", "blue", "orange", "yellow", "gray", "purple"].map(
                  (item) => (
                    <Col span={4} key={item}>
                      <Button
                        onClick={() => {
                          setColor(item);
                        }}
                        className={`primary beam-btn ${
                          item === color ? "beam-btn-active" : ""
                        }`}
                      >
                        <ReactSVG
                          src="/images/map-plain-icon.svg"
                          className={`${item}-icon`}
                        />
                      </Button>
                    </Col>
                  )
                )}
              </Row>
            </React.Fragment>
          )}
          <h5 className="mt-3">Location Description</h5>
          <Row className="mt-2">
            <Col span={24}>
              <TextArea
                value={description}
                onChange={(e: any) => setDescription(e.target.value)}
                autoSize={{ minRows: 4, maxRows: 6 }}
                placeholder="Description"
              />
            </Col>
          </Row>
          <Row className="d-flex px-2">
            <Col>
              <p>Optional</p>
            </Col>
            <Col>
              <p>max. 500 character</p>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col span={24}>
              <Select
                mode="multiple"
                className="w-full"
                placeholder="Profile"
                value={profile}
              />
            </Col>
          </Row>

          {marker.type !== "marker" && (
            <React.Fragment>
              <hr />
              <h5>Select shape color</h5>
              <Row className="mt-3">
                <Col span={24}>
                  <CompactPicker color={color} />
                </Col>
              </Row>
            </React.Fragment>
          )}

          {marker.mode !== "viewOnly" && (
            <React.Fragment>
              {type === "marker" && (
                <React.Fragment>
                  <Row className="d-flex px-2 mt-3">
                    <Col span="7">
                      <h5>Disable ETA</h5>
                    </Col>
                    <Col span="6">
                      <Switch
                        checked={eta.enable}
                        onChange={() => {
                          updateEta("enable", !eta.enable);
                        }}
                      />
                    </Col>
                    <Col span="11">
                      <Input
                        type={"number"}
                        value={eta.estimatedTime}
                        onChange={(e) =>
                          updateEta("estimatedTime", parseInt(e.target.value))
                        }
                        placeholder="Minutes"
                      />
                    </Col>
                  </Row>
                  <hr />
                </React.Fragment>
              )}
              <Row className="geofence-panel mt-3">
                <Col span={24}>
                  <Row className="d-flex">
                    <Col>
                      <h5>Geofence</h5>
                    </Col>
                    <Col>
                      <Switch
                        checked={geocode.enable}
                        onChange={() => {
                          updateGeocode("enable", !geocode.enable);
                        }}
                      />
                    </Col>
                  </Row>
                  {type === "marker" && (
                    <Row className="mt-2">
                      <Col span={24}>
                        <Input
                          type={"number"}
                          value={geocode.radius}
                          onChange={(e) =>
                            updateGeocode("radius", parseInt(e.target.value))
                          }
                          placeholder="Radius(m)"
                        />
                      </Col>
                    </Row>
                  )}
                  <Row className="d-flex pl-2 mt-3">
                    <Col span="7">
                      <h5>Alert on:</h5>
                    </Col>
                    <Col>
                      <Checkbox.Group
                        onChange={(values) => {
                          updateGeocode("alertOn", values);
                        }}
                        value={geocode.alertOn}
                        options={["Enter", "Exit", "Inside"]}
                      />
                    </Col>
                  </Row>

                  {geocode.alertOn.indexOf("Inside") !== -1 && (
                    <Row className="mt-3">
                      <Col span={24}>
                        <Input
                          type={"number"}
                          value={geocode.insideMinutes}
                          onChange={(e) =>
                            updateGeocode(
                              "insideMinutes",
                              parseInt(e.target.value)
                            )
                          }
                          placeholder="Inside (minutes)"
                        />
                      </Col>
                    </Row>
                  )}

                  <Row className="mt-3">
                    <Col span={24}>
                      <div className="datetime-item">
                        <img src="/images/date.png" />
                        <DatePicker
                          onChange={(date) => {
                            updateGeocode("expiry", date.valueOf());
                          }}
                          placeholder="Expiration date"
                          suffixIcon={<DownOutlined />}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Panel>
      </Collapse>
      <Row className="action-grp d-flex mt-2">
        <Col span={12} className="pr-2">
          <Button
            className="beam-btn blue-btn cover w-full"
            onClick={handleDirection}
          >
            Directions
          </Button>
        </Col>
        <Col span={12} className="pl-2">
          <Button className="beam-btn yellow-btn cover w-full">
            Navigation
          </Button>
        </Col>
      </Row>
      {type !== "gps" && marker.mode !== "viewOnly" && (
        <Row className="action-grp d-flex mt-3">
          <Col span={12} className="pr-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Col>
          <Col span={12} className="pl-2">
            <Button
              className="beam-btn green-btn bordered w-full"
              onClick={handleSave}
            >
              Save
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default PinPop;
